
import settings from "repositories/settingRepository";
import { UnitSystem } from "api/enums/unit-system";

export class TimeEntryPresentTemplate {
    activate(params) {
        this.presences = params.data;
        this.UnitSystemToDisplay = this.getUnitSystem();
        this.UnitSystem = UnitSystem;
    }

    getUnitSystem() {
        const unitSystem = settings.getUnitSystem();
        return unitSystem ? unitSystem : UnitSystem.Metric;
    }
}